<div fxLayout.gt-md="row" fxLayout="column" fxLayoutAlign="space-between stretch">

  <mat-card fxFlex="100">
    <mat-card-content>
      <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row"
             fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>
            Storeys |
            <span *ngIf="isNewStoreyFeed" class="text-warning ifc-link" (click)="toggleNewStoreySettings()"
                  matBadgeColor="warn" [matBadge]="storeySettings.length" matBadgeOverlap="false">
              Show
              Existing
            </span>
            <span *ngIf="!isNewStoreyFeed" class="text-success ifc-link" (click)="toggleNewStoreySettings()"
                  matBadgeColor="accent" [matBadge]="newStoreySettings.length" matBadgeOverlap="false">Show New</span>
          </label>

          <button type="button" class="add-action-button" mat-flat-button color="accent"
                  (click)="saveStoreySettings()" [disabled]="!isStoreySettingsDirty || loading">
            <mat-icon>done</mat-icon> Save
          </button>
        </div>

        <ng-container *ngIf="isNewStoreyFeed">
          <mat-card *ngFor="let storeySetting of newStoreySettings" class="contrast">
            <mat-card-content fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
              <mat-form-field>
                <mat-label>Storey Name</mat-label>
                <input type="text" matInput placeholder="Storey Name" [(ngModel)]="storeySetting.storeyName" readonly>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Storey Level</mat-label>
                <mat-select [(ngModel)]="storeySetting.storeyLevel" #storeyLevel="ngModel" required>
                  <mat-option *ngFor="let item of storeyLevelEnum | enumKeyValue | slice:1" [value]="item.value">
                    {{ getEnumKeyForDisplay(item.key) }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="storeyLevel.errors?.['required']">
                  Storey Level is <strong>required</strong>
                </mat-error>
                <mat-hint *ngIf="storeySetting.suggestedStoreyLevel !== undefined && storeySetting.storeyLevel === undefined"
                          class="text-warning ifc-link" align="end" (click)="useSuggestedStoreyLevel(storeySetting)">
                  set to
                  {{getEnumKeyForDisplay(storeyLevelEnum[storeySetting.suggestedStoreyLevel])}}?
                </mat-hint>
              </mat-form-field>
            </mat-card-content>
          </mat-card>

          <div *ngIf="newStoreySettings.length == 0 && !loading">
            No new storeys to configure, perfect!
          </div>

          <div *ngIf="newStoreySettings.length == 0 && loading">
            Loading storey settings...
          </div>

          <mat-paginator *ngIf="newStoreySettings.length" (page)="onNewStoreysPageChange($event)"
                         [pageIndex]="newStoreySettingsPageIndex" [length]="newStoreySettings.length" [pageSize]="pageSize"
                         aria-label="Select page" hidePageSize="true">
          </mat-paginator>
        </ng-container>

        <ng-container *ngIf="!isNewStoreyFeed">
          <mat-card *ngFor="let storeySetting of pagedStoreySettings" class="contrast">
            <mat-card-content fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
              <mat-form-field>
                <mat-label>Storey Name</mat-label>
                <input type="text" matInput placeholder="Storey Name" [(ngModel)]="storeySetting.storeyName" readonly>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Storey Level</mat-label>
                <mat-select [(ngModel)]="storeySetting.storeyLevel" #storeyLevel="ngModel" required>
                  <mat-option *ngFor="let item of storeyLevelEnum | enumKeyValue | slice:1" [value]="item.value">
                    {{ getEnumKeyForDisplay(item.key) }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="storeyLevel.errors?.['required']">
                  Storey Level is <strong>required</strong>
                </mat-error>
              </mat-form-field>
              <button mat-icon-button color="accent" aria-label="Remove" (click)="removeStoreySetting(storeySetting);">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-card-content>
          </mat-card>

          <div *ngIf="storeySettings.length == 0 && !loading">
            No storeys have been configured.
          </div>

          <div *ngIf="storeySettings.length == 0 && loading">
            Loading storey settings...
          </div>

          <mat-paginator *ngIf="storeySettings.length" (page)="onStoreysPageChange($event)"
                         [pageIndex]="storeySettingsPageIndex" [length]="storeySettings.length" [pageSize]="pageSize"
                         aria-label="Select page" hidePageSize="true">
          </mat-paginator>
        </ng-container>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card ngStyle.gt-md="max-width: 450px;">
    <mat-card-content>
      <h2>Documentation</h2>

      <p>This configuration matches storeys that are defined in your CAD files to a concise set of storeys that the Situ software understands.</p>
      <h3>How are Storeys Used</h3>
      <p>Storeys are used to determine how to recreate floor plans. They are also used to hide levels when a cutaway view of a particular floor is requested.</p>
      <h3>Choosing a Storey</h3>
      <p>
        Only the items that are within the
        <code>Ground Floor</code> and
        <code>First Floor</code> will be shown on the floor plans, all other details will be hidden.
      </p>
      <p>
        In some cases, your CAD software may include additional storeys for each change of elevation. For example a separate storey for the ground floor and the garage. Situ systems sees these both as a part of the
        <code>Ground Floor</code>.
      </p>
      <p>
        When creating a cutaway view of a particular floor, any storeys above the chosen floor's ceiling is hidden, including the roof. The
        <code>Outdoors</code> level is always shown.
      </p>

    </mat-card-content>
  </mat-card>

</div>
